import { useLocation } from 'react-router'
import SiteNav from './site-nav'
import { isApplyFlowPath } from '@/lib/business-app-path'

export default function SiteNavConditional() {
  const { pathname } = useLocation()
  if (pathname.startsWith('/embedded-persona')) {return null}
  if (isApplyFlowPath(pathname)) {return null}
  if (pathname.startsWith('/admin')) {return null}
  if (pathname.startsWith('/approval')) {return null}
  return <SiteNav />
}
